<ion-card class="outline-card" *ngIf="knowledgeBaseArticles?.length || searchText || isLoading">
  <div class="top-searchbar flex-space-between">
    <ion-searchbar
      mode="ios"
      placeholder="Search articles..."
      showCancelButton="never"
      [(ngModel)]="searchText"
      (ionChange)="handleFilters()"
    >
    </ion-searchbar>
    <div class="flexed">
      <ion-button (click)="delete()" color="danger" fill="clear" [hidden]="!selectedKnowledgeBaseArticles.length">
        <ion-icon name="trash-outline"></ion-icon>
        <span class="hidden-sm text-with-left-icon"> Delete </span>
      </ion-button>
      <ion-button
        (click)="editTags()"
        [color]="selectedKnowledgeBaseArticles.length ? 'primary' : 'light'"
        [disabled]="!selectedKnowledgeBaseArticles.length"
      >
        <ion-icon name="pricetag-outline"></ion-icon>
        <span class="hidden-sm text-with-left-icon"> Edit tags </span>
      </ion-button>
    </div>
  </div>

  <ngx-datatable
    class="material"
    columnMode="force"
    [limit]="100"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="50"
    [scrollbarH]="true"
    [rows]="knowledgeBaseArticles"
    [reorderable]="true"
    [selected]="selectedKnowledgeBaseArticles"
    selectionType="checkbox"
    [selectAllRowsOnPage]="false"
    (select)="onSelect($event)"
  >
    <ngx-datatable-column
      [width]="30"
      [sortable]="false"
      [canAutoResize]="false"
      [draggable]="false"
      [resizeable]="false"
      [headerCheckboxable]="true"
      [checkboxable]="true"
    >
    </ngx-datatable-column>

    <ngx-datatable-column name="Title" prop="title" [minWidth]="350">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <a class="row-title row-link" (click)="editKnowledgeBaseArticle(row.id)">
          {{ value || '(no title)' }}
        </a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="URL" prop="url" [minWidth]="200">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <a href="{{ value }}" target="_blank">{{ value }}</a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Status" prop="status" [minWidth]="50" [maxWidth]="75">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <ion-badge [color]="value === 'active' ? 'success' : 'light'"> {{ value }}</ion-badge>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Limit Access to Users" [minWidth]="250" [sortable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-chip
          mode="ios"
          color="primary"
          class="btn-small tag-chip"
          style="margin: -5px 3px 0px 0px"
          *ngFor="let userGroup of row.userGroups"
          (click)="showUserGroupOptions(row.id, userGroup.id)"
        >
          <ion-label>
            <span [title]="getUserGroupsForRow(row)"> {{ userGroup.name }} </span>
          </ion-label>
        </ion-chip>
        <ion-button
          class="btn-small"
          fill="clear"
          color="dark"
          style="--padding-start: 4px; margin: -5px 3px 0px 0px; --padding-end: 4px"
          (click)="addUserGroupToArticle(row.id)"
        >
          <ion-label> <ion-icon name="people"></ion-icon><ion-icon name="add-outline"></ion-icon> </ion-label>
        </ion-button>
      </ng-template>
    </ngx-datatable-column>

    <ng-container *ngIf="!authService.tenant.accountsEnabled">
      <ngx-datatable-column name="Limit Access to Customer Tags" [minWidth]="250" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-chip
            mode="ios"
            color="primary"
            class="btn-small tag-chip"
            style="margin: -5px 3px 0px 0px"
            *ngFor="let tag of row.tags"
            (click)="showTagOption(row.id, tag.id)"
          >
            <ion-label>
              <span [title]="getTagsForRow(row)"> {{ tag.name }} </span>
            </ion-label>
          </ion-chip>
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            style="--padding-start: 4px; margin: -5px 3px 0px 0px; --padding-end: 4px"
            (click)="addTagToArticle(row.id)"
          >
            <ion-label> <ion-icon name="pricetag"></ion-icon><ion-icon name="add-outline"></ion-icon> </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>
    </ng-container>

    <ngx-datatable-column name="Updated at" prop="updatedAt" [minWidth]="100" [maxWidth]="100">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        {{ value | date: 'M/d/yyyy' }}
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</ion-card>

<div class="empty-state-container" style="height: 70vh" *ngIf="!isLoading && !knowledgeBaseArticles.length">
  <span class="placeholder-emoji">
    <ion-icon name="book-outline"></ion-icon>
  </span>
  <div *ngIf="selectedJobId">
    <h1 class="placeholder-title">No articles found</h1>
  </div>
  <div *ngIf="!selectedJobId">
    <h1 class="placeholder-title">Sync Your Knowledge Base for AI Answers</h1>
    <p>
      Unthread AI can suggest or send AI-generated responses based on your knowledge base articles.
      <a href="https://docs.unthread.io" target="_blank">Learn more about Unthread AI</a>
    </p>
    <ion-button fill="clear" (click)="createKnowledgeBaseArticle()"> Add to knowledge base </ion-button>
  </div>
</div>
